import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { shippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import { billingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

pageHeaderStyles.buttonsWrapper = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: fixed;
                    padding: 0px 15px;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    z-index: 1;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};

pageHeaderStyles.continueButton = {
    mergeCss: true,
    css: css`
        margin-top: 15px;
        width: 100%;
    `,
};

shippingAddressStyles.oneTimeAddressCheckbox = {
    css: css`
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

shippingAddressStyles.selectSavedAddressLink = {
    css: css`
        margin-left: 8px;
        font-size: 18px;
        @media (min-width: 992px) and (max-width: 1200px) {
            font-size: 14px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                    css`
                    font-size: 15px;
                    `,
                    css`
                    font-size: 15px;
                    `,
                    css`
                    font-size: 15px;
                    `,
                    null,
                    null,
                ])}
    `,
};

shippingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
        @media (min-width: 992px) and (max-width: 1200px) {
            font-size: 14px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                    css`
                    font-size: 15px;
                    `,
                    css`
                    font-size: 15px;
                    `,
                    css`
                    font-size: 15px;
                    `,
                    null,
                    null,
                ])}
    `,
};

billingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
        @media (min-width: 992px) and (max-width: 1200px) {
            font-size: 14px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
        css`
        font-size: 15px;
        `,
        css`
        font-size: 15px;
        `,
        css`
        font-size: 15px;
        `,
        null,
        null,
    ])}
    `,
};

billingAddressStyles.selectSavedAddressLink = {
    css: css`
        margin-left: 8px;
        font-size: 18px;       
        @media (min-width: 992px) and (max-width: 1200px) {
            font-size: 14px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
        css`
        font-size: 15px;
        `,
        css`
        font-size: 15px; 
        `,
        css`
        font-size: 15px;
        `,
        null,
        null,
    ])}
    `,
};
